/* ──────────────────────────────────────────────────────────────────────────
   exportsApi.js — فراخوانی سرویس‌های «ایجاد فایل» تنظیم حساب
   /api/accounting/exports/...  (backend/accounting/views/file_exports.py)

   دانلود با fetch انجام می‌شود چون آدرس‌ها با توکن Bearer محافظت می‌شوند؛ نام فایل
   از هدر Content-Disposition (filename*=UTF-8'') خوانده می‌شود تا نام فارسی حفظ شود.
   ────────────────────────────────────────────────────────────────────────── */

const BASE = '/api/accounting/exports';

function qs(params) {
  const p = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return;
    p.append(k, typeof v === 'boolean' ? (v ? '1' : '0') : String(v));
  });
  return p.toString();
}

async function authFetch(url, opts = {}) {
  const run = () => fetch(url, {
    ...opts,
    headers: { ...(opts.headers || {}), Authorization: `Bearer ${localStorage.getItem('access')}` },
  });
  let res;
  try { res = await run(); }
  catch (e) { throw new Error('ارتباط با سرور برقرار نشد؛ چند لحظه بعد دوباره تلاش کنید'); }
  if (res.status === 401) {
    const refresh = localStorage.getItem('refresh');
    if (refresh) {
      const rr = await fetch('/api/auth/token/refresh/', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ refresh }),
      });
      if (rr.ok) {
        const data = await rr.json();
        localStorage.setItem('access', data.access);
        if (data.refresh) localStorage.setItem('refresh', data.refresh);
        res = await run();
      }
    }
  }
  return res;
}

async function errMsg(res) {
  try {
    const j = await res.json();
    return j.msg || j.error || 'خطا در ایجاد فایل';
  } catch (e) {
    return `خطا در ایجاد فایل (کد ${res.status})`;
  }
}

function fileNameOf(res, fallback) {
  const cd = res.headers.get('Content-Disposition') || '';
  const m = cd.match(/filename\*=UTF-8''([^;]+)/i);
  if (m) {
    try { return decodeURIComponent(m[1]); } catch (e) { /* ignore */ }
  }
  const m2 = cd.match(/filename="([^"]+)"/i);
  return m2 ? m2[1] : fallback;
}

function saveBlob(blob, name) {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 60000);
}

/** GET → JSON ({ok, data, msg}) */
export async function exportJson(path, params) {
  const res = await authFetch(`${BASE}${path}?${qs(params)}`);
  const j = await res.json().catch(() => ({ ok: false, msg: `پاسخ نامعتبر از سرور (کد ${res.status})` }));
  if (!res.ok || !j.ok) throw new Error(j.msg || j.error || `خطا در پاسخ سرور (کد ${res.status})`);
  return j.data;
}

/** POST JSON → JSON */
export async function exportPost(path, body) {
  const res = await authFetch(`${BASE}${path}`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body || {}),
  });
  const j = await res.json().catch(() => ({ ok: false, msg: `پاسخ نامعتبر از سرور (کد ${res.status})` }));
  if (!res.ok || !j.ok) throw new Error(j.msg || j.error || `خطا در پاسخ سرور (کد ${res.status})`);
  return j.data;
}

/** GET → دانلود فایل */
export async function exportDownload(path, params, fallbackName) {
  const res = await authFetch(`${BASE}${path}?${qs(params)}`);
  if (!res.ok) throw new Error(await errMsg(res));
  const name = fileNameOf(res, fallbackName || 'file');
  saveBlob(await res.blob(), name);
  return name;
}

/** POST → دانلود فایل */
export async function exportPostDownload(path, body, fallbackName) {
  const res = await authFetch(`${BASE}${path}`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body || {}),
  });
  if (!res.ok) throw new Error(await errMsg(res));
  const name = fileNameOf(res, fallbackName || 'file');
  saveBlob(await res.blob(), name);
  return name;
}
